"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi.js"));
var _store = require("@/api/store");
var _selectProducts = _interopRequireDefault(require("../../business/supplier/coupons/selectProducts.vue"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var _bindChannel = _interopRequireDefault(require("./bindChannel.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SelectProducts: _selectProducts.default,
    BindChannel: _bindChannel.default
  },
  data: function data() {
    return {
      visibleDrawer: false,
      //是否为展开
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      initDetail: {},
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false,
        checkStrictly: true
      },
      merCateList: [],
      brandOption: [],
      // 品牌
      selectIds: [],
      selectLists: [],
      bindDetials: {}
    };
  },
  mounted: function mounted() {
    this.getCategorySelect();
    this.searchBrand('');
    this.listData = {
      list: [],
      total: 0
    };
  },
  methods: _defineProperty(_defineProperty(_defineProperty({
    throttle: _throttle.default,
    // 打开
    initOpen: function initOpen(row) {
      this.initDetail = row || {};
      this.handlerGetListData(this.listPram);
      this.getBindDetial();
      this.visibleDrawer = true;
    },
    // 关闭
    closeDrawer: function closeDrawer() {
      this.visibleDrawer = false;
    },
    // 搜索
    handerSearch: function handerSearch() {
      var _this$listPram;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!((_this$listPram = this.listPram) !== null && _this$listPram !== void 0 && _this$listPram.brandId) && type == 'brand') {
        this.searchBrand('');
      }
      ;
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    // 列表分页查询
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      fudouActiveApi.productList(_objectSpread(_objectSpread({}, pram), {}, {
        channelId: this.initDetail.id
      })).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    // 翻页
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // 商户分类
    getCategorySelect: function getCategorySelect() {
      var _this2 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this2.merCateList = res;
      }).catch(function (res) {
        _this2.$message.error(res.message);
      });
    },
    // 品牌查询
    searchBrand: function searchBrand() {
      var _this3 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      suplierCouponsApi.getAllBrand(keyword).then(function (res) {
        _this3.brandOption = res && res.length && res.map(function (item) {
          var _ref = item || {},
            id = _ref.id,
            brandName = _ref.brandName;
          return {
            id: id,
            brandName: brandName,
            brandStr: "".concat(brandName, "--ID").concat(id)
          };
        }) || [];
      });
    },
    // 搜索品牌
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this4 = this;
      this.throttle(function () {
        _this4.searchBrand(data);
      }, 300)();
    },
    // 批量移除
    batchRemove: function batchRemove(removeIds) {
      var _this5 = this;
      this.$confirm('移除后数据不能被恢复，确认移除吗！', '确定移除').then(function (result) {
        fudouActiveApi.deleteBind({
          skuIds: removeIds,
          channelId: _this5.initDetail.id
        }).then(function (data) {
          _this5.$message.success('删除数据成功');
          _this5.handlerGetListData(_this5.listPram);
          _this5.selectIds = [];
          _this5.selectLists = [];
        });
      });
    },
    addProducts: function addProducts() {
      var _this$$refs$BindChann;
      (_this$$refs$BindChann = this.$refs['BindChannelRef']) === null || _this$$refs$BindChann === void 0 ? void 0 : _this$$refs$BindChann.openInit(this.initDetail);
    }
  }, "closeDrawer", function closeDrawer() {
    this.visibleDrawer = false;
    this.$emit('doRefresh');
  }), "handleSelectionChange", function handleSelectionChange(selection) {
    this.selectIds = selection.map(function (item) {
      return item.skuId;
    });
    this.selectLists = selection || [];
  }), "getBindDetial", function getBindDetial() {
    var _this$initDetail,
      _this6 = this;
    this.bindDetials = {};
    if (!((_this$initDetail = this.initDetail) !== null && _this$initDetail !== void 0 && _this$initDetail.id)) return;
    fudouActiveApi.getChannelBind(this.initDetail.id).then(function (res) {
      _this6.bindDetials = res || {};
    });
  })
};